'use client';

import type { GetProject } from '@/server/api/rest/project';
import { useTranslateProject } from '@/shared/hooks';
import { useDatabaseTranslation } from '@/shared/hooks/translation';
import type { FC } from 'react';
import React from 'react';
import { QueryWrapper } from './query-wrapper';
import { useParams } from 'next/navigation';

export const TranslatedProject: FC<{
  project: GetProject;
  renderProject: (project: GetProject) => React.ReactNode;
}> = ({ project, renderProject }) => {
  const params = useParams();
  const locale = (params?.locale as string) ?? 'en';

  const {
    data: translation,
    isLoading,
    error,
  } = useDatabaseTranslation({
    model: 'Project',
    fields: 'title, subtitle, challenge, solution, result',
    foreignKey: String(project.id),
    locale: locale ?? 'en',
    enabled: Boolean(locale) && locale !== 'en' && !!project,
  });

  const { project: translatedProject } = useTranslateProject({
    translation,
    project,
  });

  return (
    <QueryWrapper isLoading={isLoading} error={error} data={translatedProject}>
      {renderProject}
    </QueryWrapper>
  );
};
